'use client';

import React from 'react';
import { Locale } from '../../../../i18n-config';
import SectionLabel from '../home/SectionLabel';
import StepCards, { StepCardItem } from '../_shared/sections/StepCards';
import { useTranslation } from '@/i18n/client';
import { HiCursorArrowRays, HiShare, HiSparkles, HiUserGroup } from 'react-icons/hi2';

type Props = { lang: Locale };

type StepKey = 'design' | 'share' | 'collect' | 'follow';
type StepCopy = { num: string; title: string; description: string };

const STEP_NUMS: Record<StepKey, string> = {
  design: '01',
  share: '02',
  collect: '03',
  follow: '04',
};

const STEP_ICONS: Record<StepKey, StepCardItem['Icon']> = {
  design: HiSparkles,
  share: HiShare,
  collect: HiUserGroup,
  follow: HiCursorArrowRays,
};

const KEYS: StepKey[] = ['design', 'share', 'collect', 'follow'];

const SignupFormsHowItWorks = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  const copyFor = (k: StepKey): StepCopy => ({
    num: STEP_NUMS[k],
    title: t(`SignupForms/HowItWorks/${k}/title`),
    description: t(`SignupForms/HowItWorks/${k}/body`),
  });

  const steps: StepCardItem[] = KEYS.map((k) => {
    const c = copyFor(k);
    return {
      key: k,
      num: c.num,
      title: c.title,
      description: c.description,
      Icon: STEP_ICONS[k],
    };
  });

  return (
    <section
      id="how-it-works"
      className="px-6 py-24 lg:py-28"
      style={{
        background: '#0E1130',
        borderTop: '1px solid rgba(255,255,255,0.05)',
        color: '#F5F7FA',
      }}
    >
      <div className="mx-auto max-w-[1200px]">
        <SectionLabel num="02" label={t('SignupForms/HowItWorks/badge')} />
        <h2
          className="font-bold tracking-tight"
          style={{
            fontSize: 'clamp(28px, 3.4vw, 48px)',
            lineHeight: 1.1,
            letterSpacing: '-0.02em',
            margin: '12px 0 14px',
            maxWidth: 820,
          }}
        >
          {t('SignupForms/HowItWorks/title1')}{' '}
          <span style={{ color: '#B4C1D8' }}>{t('SignupForms/HowItWorks/title2')}</span>
        </h2>
        <p
          style={{
            color: '#B4C1D8',
            fontSize: 18,
            maxWidth: 720,
            lineHeight: 1.5,
            margin: '0 0 48px',
          }}
        >
          {t('SignupForms/HowItWorks/subtitle')}
        </p>

        <StepCards steps={steps} accent="#22D3EE" minCardWidth={240} showArrow />
      </div>
    </section>
  );
};

export default SignupFormsHowItWorks;
